import {UserManagerSettings, WebStorageStateStore} from "oidc-client-ts";

const authority = import.meta.env.VITE_OIDC_AUTHORITY;
const clientId = import.meta.env.VITE_OIDC_CLIENTID;
const redirectUri = import.meta.env.VITE_OIDC_REDIRECT_URI;
const postLogoutRedirectUri = import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI;

export const oidcConfig: UserManagerSettings = {
    authority: authority,
    client_id: clientId,
    redirect_uri: redirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri,
    response_type: "code",
    scope: "openid profile email offline_access",
    automaticSilentRenew: true, // Active le renouvellement silencieux
    accessTokenExpiringNotificationTimeInSeconds: 30, // Renouveler 30s avant expiration (défaut: 60s)
    userStore: new WebStorageStateStore({ store: window.localStorage }), // Précise le stockage à utiliser
};
